import React, { useState, useEffect } from "react";
import validator from "validator";
import axios from "axios";
import { useAuth } from "../contexts/auth";
import { postUpdatePassword } from "../utils/api";
import {
    Flex,
    Spacer,
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalCloseButton,
    FormControl,
    FormLabel,
    Input,
    Text,
    InputGroup,
    InputRightElement
  } from "@chakra-ui/react";

function UpdatePassword({
    isOpen,
    onClose,
    successCallback
}) {

    const [ currentPassword, setCurrentPassword ] = useState('');
    const [ password, setPassword ] = useState('');

    const [ invCurrentPassword, setInvCurrentPassword ] = useState(null);
    const [ invPassword, setInvPassword ] = useState(null);


    const [ showCurrentPassword, setShowCurrentPassword ] = useState(false);
    const [ showPassword, setShowPassword ] = useState(false);

    const { auth } = useAuth();
    const [ errors, setErrors ] = useState([]);
    const [ submitting, setSubmitting ] = useState(false);

    const postUpdate = (e) => {
        e.preventDefault();

        setSubmitting(true);
        // console.log(email, password);
        axios.post(postUpdatePassword, {
            currentPassword,
            password,
        },{
            headers: {
                Authorization: `Bearer ${auth.authToken}`
            }
        }).then(result => {
            if (result.status === 200) {
                // const roles = result.data.data.user.roles;
                const user = result.data.data;
                // console.log(user);
                if (successCallback) {
                    successCallback();
                }
                setCurrentPassword('');
                setPassword('');
                onClose();
            } else {
                setErrors(result.data.errors);
            }
        }).catch(e => {
            if (e.response === undefined) {
                setErrors(['Could not connect to server!'])
            } else {
                setErrors(e.response.data.errors)
            }
        }).finally(e => {
            setSubmitting(false);
        });
    }

    useEffect(() => {

        if (!validator.isEmpty(currentPassword)) {
            setInvCurrentPassword(currentPassword.length < 8);
        }
 
        if (!validator.isEmpty(password)) {
            setInvPassword(password.length < 8);
        }

    }, [password, currentPassword]);

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
            <ModalHeader>Update Password</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
                <form onSubmit={postUpdate}>
                <FormControl >

                    <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                        Current Password
                    </FormLabel>
                    <InputGroup size="md">
                        <Input
                            borderRadius="15px"
                            mb="24px"
                            fontSize="sm"        
                            type={showCurrentPassword ? "text" : "password"}
                            placeholder="Enter Current Password"
                            size="md"
                            isInvalid={invCurrentPassword === true}
                            isRequired={true}
                            value={currentPassword} 
                            onChange={e => setCurrentPassword(e.target.value)} 
                        />
                        <InputRightElement width="4.5rem">
                            <Button h="1.75rem" size="sm" onClick={() => setShowCurrentPassword(!showCurrentPassword)}>
                            {showCurrentPassword ? "Hide" : "Show"}
                            </Button>
                        </InputRightElement>
                    </InputGroup>

                    <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                        Password
                    </FormLabel>

                    <InputGroup size="md">
                        <Input
                            borderRadius="15px"
                            mb="36px"
                            fontSize="sm"
                            type={showPassword ? "text" : "password"}
                            placeholder="New Password"
                            size="md"
                            isInvalid={invPassword === true}
                            isRequired={true}
                            value={password} 
                            onChange={e => setPassword(e.target.value)}
                        />
                        <InputRightElement width="4.5rem">
                            <Button h="1.75rem" size="sm" onClick={() => setShowPassword(!showPassword)}>
                            {showPassword ? "Hide" : "Show"}
                            </Button>
                        </InputRightElement>
                    </InputGroup>

                    <Flex w="100%" flexDir="column">
                        { errors.length > 0 && <Text color="red">{errors[0]}</Text> }
                    </Flex>
                    <Button
                        fontSize="10px"
                        type="submit"
                        bg="teal.300"
                        w="100%"
                        h="45"
                        mb="20px"
                        color="white"
                        mt="0px"
                        _hover={{
                        bg: "teal.200",
                        }}
                        _active={{
                        bg: "teal.400",
                        }}
                        isDisabled={submitting}
                    >
                        SUBMIT
                    </Button>
                </FormControl>
                </form>
            </ModalBody>

            </ModalContent>
        </Modal>
    );

}



export default UpdatePassword;
